// store/apis/favorites.api.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const favoritesApi = createApi({
  reducerPath: "favoritesApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Favorite", "Property"],
  endpoints: (build) => ({
    // POST /favorites/toggle
    // userId is sourced from the JWT on the backend — no need to pass it
    // in the body. We keep the userId parameter in the hook signature for
    // backwards compatibility with existing callers, but it's ignored.
    toggleFavorite: build.mutation({
      query: ({ propertyId }) => ({
        url: "/favorites/toggle",
        method: "POST",
        body: { propertyId },
      }),
      invalidatesTags: (_result, _error, { propertyId }) => [
        "Favorite",
        { type: "Property", id: propertyId },
      ],
      transformResponse: (response) => {
        const data = response?.data ?? {};
        return {
          isFavorite: Boolean(data.isFavorite),
          favorite: data.favorite ?? null,
        };
      },
    }),

    // GET /favorites — returns the authenticated user's favorites.
    // The previous /user/:userId form was removed because it let any
    // authenticated user request another user's favorites.
    getFavoritesByUserId: build.query({
      query: () => ({
        url: "/favorites",
        method: "GET",
      }),
      providesTags: ["Favorite"],
      transformResponse: (response) => {
        const favorites = response?.data?.favorites ?? [];
        const favoritedIds = favorites.map((f) =>
          typeof f?.propertyId === "object" ? f.propertyId?._id : f?.propertyId
        );
        return { favorites, favoritedIds };
      },
    }),
  }),
});

export const { useToggleFavoriteMutation, useGetFavoritesByUserIdQuery } =
  favoritesApi;
